import React from "react";
import PropTypes from "prop-types";

export default function EditSVG({
  className,
  id,
  styles
}) {
  const {
    height,
    width,
    fill
  } = styles;

  return (
    <svg
      id={id}
      className={className}
      width={width || "32px"}
      height={height || "32px"}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>Icon/Action/Close</title>
      <g id="Icons">
        <g id="Icon/Action/Edit" fill={fill || "#677383"}>
          <path d="M25.5490294,10.1463415 L20.1333997,4.7307118 L21.9173718,2.94673967 C22.4270781,2.43703335 23.1916376,2.43703335 23.701344,2.94673967 L29.1169736,8.36236934 C29.6266799,8.87207566 29.6266799,9.63663514 29.1169736,10.1463415 L28.2249876,11.0383275 L30.9009457,11.9303136 C32.3663514,10.4649079 32.3663514,8.04380289 30.9009457,6.51468392 L25.4853161,1.09905426 C24.0199104,-0.366351419 21.5988054,-0.366351419 20.0696864,1.09905426 L5.41562967,15.753111 L0,32 L16.246889,26.5843703 L29.0532603,13.777999 L27.2692882,11.9940269 L25.5490294,10.1463415 L25.5490294,10.1463415 Z M4.14136386,27.9860627 L7.19960179,18.8113489 L13.3160777,24.9278248 L4.14136386,27.9860627 L4.14136386,27.9860627 Z M15.6734694,23.653559 L8.4738676,16.4539572 L18.4131409,6.51468392 L25.6127427,13.7142857 L15.6734694,23.653559 L15.6734694,23.653559 Z" id="edit"></path>
        </g>
      </g>
    </svg>

  );
}

EditSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

EditSVG.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#677383",
    height: "32px",
    width: "32px"
  }
};
